import { Badge, Tooltip } from 'antd'
import React from 'react'

import './ActionButton.css'

const ActionButton = ({
  iconName,
  image,
  displayArrow = false,
  className = '',
  isVertical = false,
  size = 20,
  label,
  onPress,
  isBadged,
  badgedText,
  arrowIcon = 'icon-arrow-bold-right',
  disabled,
  description,
  ...others
}) => {
  return (
    <Badge
      className={
        isVertical
          ? 'action-btn vertical ' + className
          : 'action-btn ' + className
      }
      count={badgedText}
      data-disabled={disabled}
      data-name={label}
      {...others}
    >
      <div
        className="action-btn-container"
        onClick={disabled ? null : onPress}
        data-disabled={disabled}
      >
        {iconName && (
          <span
            className={`icon-${iconName} icon`}
            style={{ fontSize: size }}
          />
        )}
        {image && (
          <img
            src={image}
            className="icon"
            style={{
              height: size,
              width: size,
              alignSelf: description ? 'flex-start' : 'center',
              objectFit: 'contain',
            }}
            alt=""
          />
        )}
        <div className="action-label">
          {label}
          <div className="description">{description}</div>
        </div>
        {displayArrow && <span className={`${arrowIcon} icon-arrow`} />}
      </div>
    </Badge>
  )
}

export default ActionButton
